import { Action } from '@ngrx/store';
import * as fromModels from '../../models';


export enum ProfileActionTypes {
  UpdateProfile = '[Profile] Update Profile',
  UpdateProfileSuccess = '[Profile] Update Profile Success',
  UpdateProfileFail = '[Profile] Update Profile Fail',

  ChangePassword = '[Profile] Change Password',
  ChangePasswordSuccess = '[Profile] Change Password Success',
  ChangePasswordFail = '[Profile] Change Password Fail',
}

export class UpdateProfile implements Action {
  readonly type = ProfileActionTypes.UpdateProfile;

  constructor(public payload: fromModels.User) { }
}

export class UpdateProfileSuccess implements Action {
  readonly type = ProfileActionTypes.UpdateProfileSuccess;
  constructor(public payload: fromModels.User) { }
}

export class UpdateProfileFail implements Action {
  readonly type = ProfileActionTypes.UpdateProfileFail;
  constructor(public payload: any) { }
}

export class ChangePassword implements Action {
  readonly type = ProfileActionTypes.ChangePassword;

  constructor(public payload: fromModels.ChangePassword) { }
}

export class ChangePasswordSuccess implements Action {
  readonly type = ProfileActionTypes.ChangePasswordSuccess;
}

export class ChangePasswordFail implements Action {
  readonly type = ProfileActionTypes.ChangePasswordFail;
  constructor(public payload: any) { }
}



export type ProfileActions =
  | UpdateProfile
  | UpdateProfileSuccess
  | UpdateProfileFail

  | ChangePassword
  | ChangePasswordSuccess
  | ChangePasswordFail



// WEBPACK FOOTER //
// ./src/app/core/store/actions/profile.actions.ts